import { delay } from "../../utils"
import { rest } from "msw"

export const paymentMethods = [
  rest.get("*/v1/:storeId/payment_methods/", function (_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./fixture.json")))
  }),
]
